import { t } from '../i18n/i18n';
import type { Issue } from '../engine/model/issues';
import { select } from './actions';

const LABEL: Record<Issue['severity'], string> = { error: 'Error', warning: 'Warning', info: 'Info' };

export function IssueList({ issues, onSelect = true }: { issues: Issue[]; onSelect?: boolean }) {
  if (!issues.length) return null;
  return (
    <ul className="issues">
      {issues.map((i, k) => (
        <li key={k} className={`issue ${i.severity}`}>
          <span>
            <span className="visually-hidden">{t(LABEL[i.severity])}: </span>
            {i.message}
          </span>
          {onSelect && i.objectId && (
            <button className="btn small ghost" onClick={() => select([i.objectId!])}>
              {t('Show')}
            </button>
          )}
        </li>
      ))}
    </ul>
  );
}

/** De-duplicates repeated messages (e.g. the same note for many objects). */
export function uniqueIssues(issues: Issue[]): Issue[] {
  const seen = new Set<string>();
  return issues.filter((i) => {
    const k = `${i.severity}|${i.code}|${i.objectId ?? ''}|${i.message}`;
    if (seen.has(k)) return false;
    seen.add(k);
    return true;
  });
}
